export const MAX_SIMULTANEOUS_IMAGES = 9;

export const SIMULTANEOUS_IMAGES_LIMIT_MESSAGE =
  'You can display up to 9 images at once. Close an image or deselect a layer to continue.';

export const IMAGE_VIEWER_CAPACITY_LIMIT_EVENT = 'image-viewer:capacity-limit';

export function isAtImageViewerCapacity(currentCount: number): boolean {
  return currentCount >= MAX_SIMULTANEOUS_IMAGES;
}

export function notifyImageViewerCapacityLimit(
  message: string = SIMULTANEOUS_IMAGES_LIMIT_MESSAGE,
): void {
  window.dispatchEvent(
    new CustomEvent(IMAGE_VIEWER_CAPACITY_LIMIT_EVENT, {
      detail: { message },
    }),
  );
}
